import React, { ReactElement, useContext } from 'react';
import { LoaderMask } from 'components/LoaderMask/LoaderMask';
import { WidgetGeneratorContext } from 'screens/WidgetGenerator/contexts/WidgetGeneratorContext';
import { OverallSentimentBarTable } from 'screens/WidgetGenerator/widgets/SentimentBarTable/OverallSentimentBarTable';
import { useAsyncEffect } from 'customHooks/hooks';
import { logger } from 'utils/logger';
import { fetchSentimentBarOverallData } from '../../helpers/fetchSentimentBarOverallData';

const DEFAULT_DATA = {
  qualityOfLifeLastCycleScores: [],
  characteristicsLastCycleScores: [],
};

export const OverallSentimentTableHOC = (): ReactElement => {
  const { client, cycles, selectedDateRange } = useContext(WidgetGeneratorContext);

  const isBenchmarked = cycles.length > 1;

  const fetchOverallSentimentData = async () => {
    const fetchedOverallData = await fetchSentimentBarOverallData({
      client,
      cycles,
      selectedDateRange,
    });
    return fetchedOverallData;
  };

  const {
    fetchedData: overallSentimentData,
    isLoading,
    error,
  } = useAsyncEffect(fetchOverallSentimentData, [client, cycles, selectedDateRange]);

  if (error) {
    logger.error(error);
  }

  return (
    <LoaderMask isLoading={isLoading}>
      <OverallSentimentBarTable widgetData={overallSentimentData ?? DEFAULT_DATA} isBenchmarked={isBenchmarked} />
    </LoaderMask>
  );
};
